module.exports = __webpack_public_path__ + "assets/img/banner-2.ca2d6669.png";